import WhimstayContainerNew from "components/utilities/WhimstayContainerNew";
import AppHeaderCenter from "./AppHeaderCenter";
import AppHeaderLeft from "./AppHeaderLeft";
import AppHeaderRight from "./AppHeaderRight";
const AppHeaderInner = () => {
  return <WhimstayContainerNew className={`app-header-bar grid min-h-[60px] grid-cols-[1fr,auto,1fr] items-center gap-0 ssm:gap-3 md:min-h-[80px]`} data-sentry-element="WhimstayContainerNew" data-sentry-component="AppHeaderInner" data-sentry-source-file="AppHeaderInner.tsx">
      <AppHeaderLeft data-sentry-element="AppHeaderLeft" data-sentry-source-file="AppHeaderInner.tsx" />
      <AppHeaderCenter data-sentry-element="AppHeaderCenter" data-sentry-source-file="AppHeaderInner.tsx" />
      <AppHeaderRight data-sentry-element="AppHeaderRight" data-sentry-source-file="AppHeaderInner.tsx" />
    </WhimstayContainerNew>;
};
export default AppHeaderInner;